import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { configService, orderService, inventoryService } from '../services/api';

const ESTADOS = ['Pendiente','En Taller','Lista','Entregada'];
const COLORS = { 'Pendiente':'#f59e0b','En Taller':'#3b82f6','Lista':'#8b5cf6','Entregada':'#10b981','Anulada':'#9ca3af' };
const fmt = n => n ? '₡' + Number(n).toLocaleString('es-CR') : '₡0';

function DocView({ order, items, type, onClose, logoUrl }) {
  const titles = { trabajo:'ORDEN DE TRABAJO', entrega:'ORDEN DE ENTREGA', factura:'FACTURA' };

  const handlePrint = () => {
    const el = document.querySelector('.print-area');
    if (!el) return;
    const html = `<html><head><meta charset="utf-8"><style>
      body{font-family:Arial,sans-serif;font-size:12px;padding:15mm;margin:0;}
      table{width:100%;border-collapse:collapse;}
      th{background:#f5ede6;padding:8px 10px;text-align:left;font-size:11px;color:#5c3d2e;border-bottom:2px solid #e0d0c0;}
      td{padding:8px 10px;border-bottom:1px solid #f0e8e0;font-size:12px;vertical-align:top;}
      .row{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid #f0e8e0;font-size:13px;}
      .label{color:#666;font-weight:600;}
      .value{font-weight:600;text-align:right;}
      .total{display:flex;justify-content:space-between;padding:12px 0;font-size:16px;font-weight:700;color:#5c3d2e;border-top:2px solid #5c3d2e;margin-top:8px;}
      .header{border-bottom:3px solid #5c3d2e;padding-bottom:16px;margin-bottom:20px;display:flex;justify-content:space-between;align-items:flex-start;}
      .title{font-size:18px;font-weight:800;color:#5c3d2e;}
      .numero{font-size:13px;font-weight:700;color:#a0522d;}
      .section{font-weight:700;font-size:13px;color:#5c3d2e;margin:16px 0 8px;}
      img{max-height:52px;object-fit:contain;}
      @page{margin:0;size:A4;}
    </style></head><body>${el.innerHTML}</body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); win.close(); }, 600);
  };

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 },
    box: { background:'#fff', borderRadius:12, padding:32, maxWidth:600, width:'90%', maxHeight:'90vh', overflowY:'auto' },
    row: { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #f0e8e0', fontSize:13 },
    th: { background:'#f5ede6', padding:'8px 10px', textAlign:'left', fontWeight:700, fontSize:12, color:'#5c3d2e', borderBottom:'2px solid #e0d0c0' },
    td: { padding:'8px 10px', borderBottom:'1px solid #f0e8e0', fontSize:13, verticalAlign:'top' },
    total: { display:'flex', justifyContent:'space-between', padding:'12px 0', fontSize:16, fontWeight:700, color:'#5c3d2e', borderTop:'2px solid #5c3d2e', marginTop:8 },
  };

  const infoRows = {
    trabajo: [['N° Orden',order.numero],['Fecha Orden',order.order_date?.split('T')[0]],['Fecha Entrega',order.delivery_date?.split('T')[0]],['Vendedor',order.vendedor],['Observaciones',order.observations||'—']],
    entrega: [['N° Orden',order.numero],['Fecha Entrega',order.delivery_date?.split('T')[0]],['Cliente',order.cliente_nombre],['Cédula',order.cedula||'—'],['Dirección',order.address||'—'],['Teléfono 1',order.phone1||'—'],['Teléfono 2',order.phone2||'—']],
    factura: [['N° Factura',order.numero],['Fecha',order.order_date?.split('T')[0]],['Cliente',order.cliente_nombre],['Cédula',order.cedula||'—'],['Teléfono',order.phone1||'—'],['Correo',order.email||'—']],
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div className="print-area" style={s.box} onClick={e=>e.stopPropagation()}>
        <div style={{ borderBottom:'3px solid #5c3d2e', paddingBottom:16, marginBottom:20 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div>
              {logoUrl ? <img src={logoUrl} alt="Logo" style={{ height:52, objectFit:'contain', marginBottom:4 }}/> : <div style={{ fontSize:20, fontWeight:900, color:'#5c3d2e' }}>🪑 Muebles Terrasol</div>}
              <div style={{ color:'#888', fontSize:13 }}>Muebles Terrasol</div>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontSize:18, fontWeight:800, color:'#5c3d2e' }}>{titles[type]}</div>
              <div style={{ fontSize:13, fontWeight:700, color:'#a0522d' }}>{order.numero}</div>
            </div>
          </div>
        </div>

        {infoRows[type].map(([l,v]) => (
          <div key={l} style={s.row}><span style={{ color:'#666', fontWeight:600 }}>{l}</span><span style={{ fontWeight:600, maxWidth:'60%', textAlign:'right' }}>{v}</span></div>
        ))}

        {items && items.length > 0 && (
          <div style={{ marginTop:16 }}>
            <div style={{ fontWeight:700, fontSize:13, color:'#5c3d2e', marginBottom:8 }}>ARTÍCULOS:</div>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr>
                  <th style={s.th}>Artículo / Descripción</th>
                  <th style={{ ...s.th, textAlign:'center' }}>Cant.</th>
                  {type === 'factura' && <th style={{ ...s.th, textAlign:'right' }}>P. Unit.</th>}
                  {type === 'factura' && <th style={{ ...s.th, textAlign:'right' }}>Subtotal</th>}
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={idx}>
                    <td style={s.td}>
                      <div style={{ fontWeight:600 }}>{item.articulo}</div>
                      {item.descripcion && <div style={{ color:'#888', fontSize:12, marginTop:2 }}>{item.descripcion}</div>}
                    </td>
                    <td style={{ ...s.td, textAlign:'center' }}>{item.cantidad}</td>
                    {type === 'factura' && <td style={{ ...s.td, textAlign:'right' }}>{fmt(item.precio_unitario)}</td>}
                    {type === 'factura' && <td style={{ ...s.td, textAlign:'right', fontWeight:600 }}>{fmt(item.subtotal)}</td>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {type === 'factura' && (
          <div style={{ marginTop:8 }}>
            <div style={s.row}><span style={{ color:'#666', fontWeight:600 }}>Subtotal artículos</span><span style={{ fontWeight:600 }}>{fmt(order.amount)}</span></div>
            <div style={s.row}><span style={{ color:'#666', fontWeight:600 }}>Envío</span><span style={{ fontWeight:600 }}>{fmt(order.shipping)}</span></div>
            <div style={s.total}><span>TOTAL</span><span>{fmt(Number(order.amount)+Number(order.shipping))}</span></div>
          </div>
        )}
        {type === 'factura' && (
          <div style={{ marginTop:20, padding:'12px', background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:8, fontSize:12, color:'#555' }}>
            <strong style={{ color:'#5c3d2e' }}>Garantía:</strong> Este producto cuenta con 1 año de garantía por defectos de fabricación, contado a partir de la fecha de entrega. La madera utilizada es curada y tratada contra plagas e insectos que afectan la madera. Esta garantía no cubre daños por mal uso, humedad, manchas, golpes, rasgaduras, desgaste normal ni infestaciones originadas por condiciones externas al producto. Para hacer válida la garantía, es indispensable presentar esta factura.
          </div>
        )}
        {type === 'factura' && (
          <div style={{ marginTop:24, display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ borderTop:'1px solid #333', paddingTop:6, fontSize:12, color:'#555' }}>Recibe conforme</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ borderTop:'1px solid #333', paddingTop:6, fontSize:12, color:'#555' }}>Repartidor</div>
            </div>
          </div>
        )}

        {order.observations && type !== 'factura' && (
          <div style={{ background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:8, padding:12, fontSize:13, marginTop:12 }}>
            <strong>📝 Observaciones:</strong> {order.observations}
          </div>
        )}

        <div style={{ display:'flex', gap:10, marginTop:20 }}>
          <button style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600 }} onClick={handlePrint}>🖨️ Imprimir</button>
          <button style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14 }} onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

const emptyItem = () => ({ articulo: '', descripcion: '', cantidad: 1, precio_unitario: '' });

function EditOrderModal({ order, items: initialItems, onClose, onSaved }) {
  const [form, setForm] = useState({
    nombre: order.cliente_nombre || '',
    cedula: order.cedula || '',
    email: order.email || '',
    direccion: order.address || '',
    tel1: order.phone1 || '',
    tel2: order.phone2 || '',
    fechaOrden: order.order_date?.split('T')[0] || '',
    fechaEntrega: order.delivery_date?.split('T')[0] || '',
    envio: order.shipping || 0,
    observaciones: order.observations || '',
  });
  const [items, setItems] = useState(
    initialItems && initialItems.length > 0
      ? initialItems.map(i => ({ articulo: i.articulo, descripcion: i.descripcion||'', cantidad: i.cantidad, precio_unitario: i.precio_unitario }))
      : [emptyItem()]
  );
  const [catalog, setCatalog] = useState([]);
  const [showCatalog, setShowCatalog] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    inventoryService.getProducts().then(res => setCatalog(res.data)).catch(() => {});
  }, []);

  const set = k => e => setForm(p => ({...p, [k]: e.target.value}));
  const setItem = (idx, k) => e => setItems(prev => prev.map((item, i) => i === idx ? { ...item, [k]: e.target.value } : item));
  const addItem = () => setItems(prev => [...prev, emptyItem()]);
  const removeItem = idx => setItems(prev => prev.filter((_, i) => i !== idx));
  const selectFromCatalog = (idx, prod, vari) => {
    setItems(prev => prev.map((item, i) => i === idx ? { ...item, articulo: `${prod.name} - ${vari.nombre}`, precio_unitario: vari.precio } : item));
    setShowCatalog(null);
  };

  const totalItems = items.reduce((sum, item) => sum + (Number(item.cantidad) * Number(item.precio_unitario || 0)), 0);
  const totalGeneral = totalItems + Number(form.envio || 0);

  const handleSave = async () => {
    if (!form.nombre || !form.direccion || !form.tel1) { alert('Completa los campos obligatorios'); return; }
    for (let item of items) {
      if (!item.articulo || !item.precio_unitario || !item.cantidad) { alert('Completa todos los campos de cada artículo'); return; }
    }
    setLoading(true);
    try {
      const res = await orderService.update(order.id, { ...form, items });
      onSaved(res.data);
    } catch (err) {
      alert('Error al guardar cambios');
    } finally {
      setLoading(false);
    }
  };

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:150 },
    box: { background:'#fff', borderRadius:12, padding:26, maxWidth:620, width:'90%', maxHeight:'90vh', overflowY:'auto' },
    label: { display:'block', marginBottom:4, fontWeight:600, fontSize:13, color:'#555' },
    input: { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', marginBottom:12 },
    grid2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0 14px' },
    textarea: { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', marginBottom:12, resize:'vertical', minHeight:60 },
    opt: { fontSize:11, color:'#aaa', fontWeight:400, marginLeft:4 },
    itemRow: { background:'#fdf8f4', border:'1px solid #e8ddd4', borderRadius:8, padding:14, marginBottom:10 },
    btnGhost: { background:'transparent', color:'#5c3d2e', border:'1px solid #d0b89a', padding:'5px 10px', borderRadius:6, cursor:'pointer', fontSize:11 },
    btnRemove: { background:'#fee2e2', color:'#ef4444', border:'none', padding:'5px 8px', borderRadius:6, cursor:'pointer', fontSize:11 },
    btnAdd: { background:'#f0fdf4', color:'#10b981', border:'1px dashed #10b981', padding:'8px 16px', borderRadius:7, cursor:'pointer', fontSize:13, width:'100%', marginTop:4 },
    totalBox: { background:'#5c3d2e', color:'#fff', borderRadius:8, padding:'12px 16px', marginTop:10 },
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.box} onClick={e=>e.stopPropagation()}>
        <h3 style={{ margin:'0 0 16px', color:'#5c3d2e' }}>✏️ Editar Orden — {order.numero}</h3>
        <div style={s.grid2}>
          <div><label style={s.label}>Fecha Orden</label><input style={s.input} type="date" value={form.fechaOrden} onChange={set('fechaOrden')}/></div>
          <div><label style={s.label}>Fecha Entrega</label><input style={s.input} type="date" value={form.fechaEntrega} onChange={set('fechaEntrega')}/></div>
        </div>
        <label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre} onChange={set('nombre')}/>
        <div style={s.grid2}>
          <div><label style={s.label}>Cédula <span style={s.opt}>(opcional)</span></label><input style={s.input} value={form.cedula} onChange={set('cedula')}/></div>
          <div><label style={s.label}>Correo <span style={s.opt}>(opcional)</span></label><input style={s.input} type="email" value={form.email} onChange={set('email')}/></div>
        </div>
        <div style={s.grid2}>
          <div><label style={s.label}>Teléfono 1 *</label><input style={s.input} value={form.tel1} onChange={set('tel1')}/></div>
          <div><label style={s.label}>Teléfono 2 <span style={s.opt}>(opcional)</span></label><input style={s.input} value={form.tel2} onChange={set('tel2')}/></div>
        </div>
        <label style={s.label}>Dirección *</label><input style={s.input} value={form.direccion} onChange={set('direccion')}/>

        <div style={{ fontWeight:700, fontSize:14, color:'#5c3d2e', margin:'16px 0 10px' }}>📦 Artículos</div>
        {items.map((item, idx) => (
          <div key={idx} style={s.itemRow}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
              <span style={{ fontWeight:600, fontSize:12, color:'#5c3d2e' }}>Artículo {idx+1}</span>
              <div style={{ display:'flex', gap:6 }}>
                <button style={s.btnGhost} onClick={() => setShowCatalog(showCatalog === idx ? null : idx)}>🔍 Catálogo</button>
                {items.length > 1 && <button style={s.btnRemove} onClick={() => removeItem(idx)}>✕</button>}
              </div>
            </div>
            {showCatalog === idx && (
              <div style={{ background:'#fff', border:'1px solid #e0d0c0', borderRadius:7, padding:10, marginBottom:8 }}>
                {catalog.map(prod => (
                  <div key={prod.id} style={{ marginBottom:6 }}>
                    <div style={{ fontWeight:600, fontSize:12, color:'#5c3d2e', marginBottom:3 }}>{prod.name}</div>
                    <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
                      {prod.variantes?.map(v => (
                        <button key={v.id} onClick={() => selectFromCatalog(idx, prod, v)}
                          style={{ background:'#f0fdf4', border:'1px solid #ddd', borderRadius:5, padding:'4px 8px', cursor:'pointer', fontSize:11 }}>
                          {v.nombre} — ₡{Number(v.precio).toLocaleString('es-CR')}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
            <label style={s.label}>Artículo *</label>
            <input style={s.input} value={item.articulo} onChange={setItem(idx, 'articulo')}/>
            <label style={s.label}>Descripción</label>
            <input style={s.input} placeholder="Color, medidas, acabado..." value={item.descripcion} onChange={setItem(idx, 'descripcion')}/>
            <div style={s.grid2}>
              <div><label style={s.label}>Cantidad *</label><input style={s.input} type="number" min="1" value={item.cantidad} onChange={setItem(idx, 'cantidad')}/></div>
              <div><label style={s.label}>Precio unitario (₡) *</label><input style={s.input} type="number" value={item.precio_unitario} onChange={setItem(idx, 'precio_unitario')}/></div>
            </div>
            {item.precio_unitario && item.cantidad && (
              <div style={{ textAlign:'right', fontSize:12, color:'#5c3d2e', fontWeight:600 }}>
                Subtotal: {fmt(Number(item.cantidad) * Number(item.precio_unitario))}
              </div>
            )}
          </div>
        ))}
        <button style={s.btnAdd} onClick={addItem}>+ Agregar otro artículo</button>

        <div style={s.grid2}>
          <div style={{ marginTop:12 }}><label style={s.label}>Flete (₡)</label><input style={s.input} type="number" value={form.envio} onChange={set('envio')}/></div>
          <div></div>
        </div>
        <div style={s.totalBox}>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, opacity:0.85, marginBottom:4 }}><span>Subtotal</span><span>{fmt(totalItems)}</span></div>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, opacity:0.85, marginBottom:8 }}><span>Flete</span><span>{fmt(Number(form.envio||0))}</span></div>
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:16, fontWeight:700, borderTop:'1px solid rgba(255,255,255,0.3)', paddingTop:8 }}><span>TOTAL</span><span>{fmt(totalGeneral)}</span></div>
        </div>

        <label style={{ ...s.label, marginTop:12 }}>Observaciones</label>
        <textarea style={s.textarea} value={form.observaciones} onChange={set('observaciones')}/>

        <div style={{ display:'flex', gap:10, marginTop:8 }}>
          <button style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'10px 24px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600, opacity:loading?0.7:1 }} onClick={handleSave} disabled={loading}>
            {loading ? 'Guardando...' : '✅ Guardar Cambios'}
          </button>
          <button style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 18px', borderRadius:7, cursor:'pointer', fontSize:13 }} onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

function AnularModal({ order, onClose, onAnulada }) {
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAnular = async () => {
    if (!motivo.trim()) { alert('Debes escribir el motivo de anulación'); return; }
    setLoading(true);
    try {
      await orderService.anular(order.id, motivo.trim());
      onAnulada();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al anular la orden');
    } finally {
      setLoading(false);
    }
  };

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:150 },
    box: { background:'#fff', borderRadius:12, padding:26, maxWidth:440, width:'90%' },
    label: { display:'block', marginBottom:6, fontWeight:600, fontSize:13, color:'#555' },
    textarea: { width:'100%', padding:'10px 12px', border:'2px solid #ef4444', borderRadius:7, fontSize:14, boxSizing:'border-box', resize:'vertical', minHeight:80, outline:'none' },
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.box} onClick={e=>e.stopPropagation()}>
        <h3 style={{ margin:'0 0 8px', color:'#ef4444' }}>🚫 Anular Orden — {order.numero}</h3>
        <p style={{ fontSize:13, color:'#666', margin:'0 0 16px' }}>Esta acción no se puede deshacer.</p>
        <label style={s.label}>Motivo de anulación *</label>
        <textarea style={s.textarea} placeholder="Escribe el motivo..." value={motivo} onChange={e=>setMotivo(e.target.value)}/>
        <div style={{ display:'flex', gap:10, marginTop:16 }}>
          <button style={{ background:'#ef4444', color:'#fff', border:'none', padding:'10px 22px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600, opacity:loading?0.7:1, flex:1 }} onClick={handleAnular} disabled={loading}>
            {loading ? 'Anulando...' : '🚫 Confirmar Anulación'}
          </button>
          <button style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'10px 18px', borderRadius:7, cursor:'pointer', fontSize:13 }} onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default function OrderDetail({ order, onClose, onStatusChange, onOrderSaved }) {
  const { user } = useAuth();
  const [docType, setDocType] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [editing, setEditing] = useState(false);
  const [anulando, setAnulando] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(order);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const url = configService.getLogoUrl();
    fetch(url).then(r => { if (r.ok) setLogoUrl(url + '?t=' + Date.now()); }).catch(()=>{});
  }, []);

  useEffect(() => {
    orderService.getOne(order.id).then(res => {
      setCurrentOrder(res.data);
      setItems(res.data.items || []);
    }).catch(() => {});
  }, [order.id]);

  const handleSaved = async () => {
    setEditing(false);
    try {
      const res = await orderService.getOne(currentOrder.id);
      setCurrentOrder(res.data);
      setItems(res.data.items || []);
      if (onOrderSaved) onOrderSaved(res.data);
    } catch { setEditing(false); }
  };

  const handleAnulada = async () => {
    setAnulando(false);
    try {
      const res = await orderService.getOne(currentOrder.id);
      setCurrentOrder(res.data);
      setItems(res.data.items || []);
      if (onOrderSaved) onOrderSaved(res.data);
    } catch { onClose(); }
  };

  const puedeAnular = currentOrder.status !== 'Anulada' && (user.role === 'admin' || currentOrder.user_id === user.id);

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
    box: { background: currentOrder.status === 'Anulada' ? '#f9f9f9' : '#fff', borderRadius:12, padding:26, maxWidth:560, width:'90%', maxHeight:'88vh', overflowY:'auto', border: currentOrder.status === 'Anulada' ? '2px solid #e5e7eb' : 'none' },
    row: { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #f0e8e0', fontSize:13 },
    badge: est => ({ background:COLORS[est]||'#aaa', color:'#fff', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600, display:'inline-block' }),
    docBtn: c => ({ background:c, color:'#fff', border:'none', padding:'7px 14px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600, marginRight:4 }),
    th: { background:'#f5ede6', padding:'7px 10px', textAlign:'left', fontWeight:700, fontSize:12, color:'#5c3d2e', borderBottom:'2px solid #e0d0c0' },
    td: { padding:'8px 10px', borderBottom:'1px solid #f0e8e0', fontSize:13, verticalAlign:'top' },
  };

  const o = currentOrder;

  if (docType) return <DocView order={o} items={items} type={docType} onClose={()=>setDocType(null)} logoUrl={logoUrl}/>;
  if (editing) return <EditOrderModal order={o} items={items} onClose={()=>setEditing(false)} onSaved={handleSaved}/>;
  if (anulando) return <AnularModal order={o} onClose={()=>setAnulando(false)} onAnulada={handleAnulada}/>;

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.box} onClick={e=>e.stopPropagation()}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <div>
            <div style={{ fontWeight:800, fontSize:16, color: o.status==='Anulada'?'#9ca3af':'#5c3d2e' }}>{o.numero}</div>
            <div style={{ fontSize:12, color:'#aaa' }}>Vendedor: {o.vendedor}</div>
          </div>
          <span style={s.badge(o.status)}>{o.status}</span>
        </div>

        {o.status === 'Anulada' && o.motivo_anulacion && (
          <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, marginBottom:14 }}>
            <strong style={{ color:'#ef4444' }}>🚫 Motivo de anulación:</strong> {o.motivo_anulacion}
          </div>
        )}

        {[
          ['Cliente', o.cliente_nombre],
          ['Cédula', o.cedula||'—'],
          ['Correo', o.email||'—'],
          ['Dirección', o.address||'—'],
          ['Tel 1', o.phone1||'—'],
          ['Tel 2', o.phone2||'—'],
          ['Fecha Orden', o.order_date?.split('T')[0]],
          ['Fecha Entrega', o.delivery_date?.split('T')[0]],
        ].map(([l,v]) => (
          <div key={l} style={s.row}><span style={{ color:'#888', fontWeight:600 }}>{l}</span><span style={{ fontWeight:600 }}>{v}</span></div>
        ))}

        {items.length > 0 && (
          <div style={{ marginTop:14 }}>
            <div style={{ fontWeight:700, fontSize:13, color:'#5c3d2e', marginBottom:8 }}>📦 ARTÍCULOS:</div>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr>
                  <th style={s.th}>Artículo / Descripción</th>
                  <th style={{ ...s.th, textAlign:'center' }}>Cant.</th>
                  <th style={{ ...s.th, textAlign:'right' }}>P. Unit.</th>
                  <th style={{ ...s.th, textAlign:'right' }}>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={idx}>
                    <td style={s.td}>
                      <div style={{ fontWeight:600 }}>{item.articulo}</div>
                      {item.descripcion && <div style={{ color:'#888', fontSize:12, marginTop:2 }}>{item.descripcion}</div>}
                    </td>
                    <td style={{ ...s.td, textAlign:'center' }}>{item.cantidad}</td>
                    <td style={{ ...s.td, textAlign:'right' }}>{fmt(item.precio_unitario)}</td>
                    <td style={{ ...s.td, textAlign:'right', fontWeight:600 }}>{fmt(item.subtotal)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ marginTop:10 }}>
          <div style={s.row}><span style={{ color:'#888', fontWeight:600 }}>Subtotal artículos</span><span style={{ fontWeight:600 }}>{fmt(o.amount)}</span></div>
          <div style={s.row}><span style={{ color:'#888', fontWeight:600 }}>Envío</span><span style={{ fontWeight:600 }}>{fmt(o.shipping)}</span></div>
          <div style={{ display:'flex', justifyContent:'space-between', padding:'10px 0', fontSize:15, fontWeight:800, color:'#5c3d2e', borderTop:'2px solid #5c3d2e', marginTop:4 }}>
            <span>TOTAL</span><span>{fmt(Number(o.amount)+Number(o.shipping))}</span>
          </div>
        </div>

        {o.observations && (
          <div style={{ background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:8, padding:10, fontSize:13, marginTop:10 }}>
            <strong>📝 Observaciones:</strong> {o.observations}
          </div>
        )}

        {user.role === 'admin' && o.status !== 'Anulada' && (
          <div style={{ marginTop:14 }}>
            <label style={{ display:'block', marginBottom:4, fontWeight:600, fontSize:13, color:'#555' }}>Cambiar Estado:</label>
            <select style={{ width:'100%', padding:'8px', border:'1px solid #ddd', borderRadius:7, fontSize:14 }}
              value={o.status} onChange={e=>{ onStatusChange(o.id, e.target.value); setCurrentOrder(p=>({...p,status:e.target.value})); }}>
              {ESTADOS.map(est=><option key={est}>{est}</option>)}
            </select>
          </div>
        )}

        {o.status !== 'Anulada' && (
          <div style={{ marginTop:16, paddingTop:14, borderTop:'1px solid #f0e8e0' }}>
            <div style={{ fontSize:12, color:'#888', marginBottom:8, fontWeight:600 }}>GENERAR DOCUMENTOS:</div>
            <button style={s.docBtn('#5c3d2e')} onClick={()=>setDocType('trabajo')}>🔧 Orden Taller</button>
            <button style={s.docBtn('#3b82f6')} onClick={()=>setDocType('entrega')}>🚚 Orden Entrega</button>
            <button style={s.docBtn('#10b981')} onClick={()=>setDocType('factura')}>🧾 Factura</button>
          </div>
        )}

        <div style={{ display:'flex', gap:8, marginTop:14, flexWrap:'wrap' }}>
          {o.status !== 'Anulada' && (
            <button style={{ background:'#f59e0b', color:'#fff', border:'none', padding:'9px 18px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, flex:1 }} onClick={()=>setEditing(true)}>
              ✏️ Editar
            </button>
          )}
          {puedeAnular && (
            <button style={{ background:'#ef4444', color:'#fff', border:'none', padding:'9px 18px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, flex:1 }} onClick={()=>setAnulando(true)}>
              🚫 Anular
            </button>
          )}
          <button style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'9px 18px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:600, flex:1 }} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
